import React from 'react';
import PropTypes from 'prop-types';
import Editor from '@components/common/Editor';
export default function TextBlock(_ref) {
  var {
    textWidget: {
      text,
      className
    }
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: "text-block-widget ".concat(className)
  }, /*#__PURE__*/React.createElement(Editor, {
    rows: text
  }));
}
TextBlock.propTypes = {
  textWidget: PropTypes.shape({
    // eslint-disable-next-line react/forbid-prop-types
    text: PropTypes.array,
    className: PropTypes.string
  })
};
TextBlock.defaultProps = {
  textWidget: {
    text: [],
    className: ''
  }
};
export var query = "\n  query Query($text: String, $className: String) {\n    textWidget(text: $text, className: $className) {\n      ...TextBlockWidget\n    }\n  }\n";
export var fragments = "\n  fragment TextBlockWidget on TextBlockWidget {\n    text\n    className\n  }\n";
export var variables = "{\n  text: getWidgetSetting(\"text\"),\n  className: getWidgetSetting(\"className\")\n}";